// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAFMPqKIYFd8IB1Z5SW0R7hfpl_14zV0-Y',
    authDomain: 'pebble-world.firebaseapp.com',
    databaseURL: 'https://pebble-world.firebaseio.com',
    projectId: 'pebble-world',
    storageBucket: 'pebble-world.appspot.com',
    messagingSenderId: '212023684848',
    appId: '1:212023684848:web:8ed73a667b5d51b69c5c35'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
